var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.8958C11 14.263 11.513 13.75 12.1458 13.75C12.7787 13.75 13.2917 14.263 13.2917 14.8958V26.8125C13.2917 27.4453 13.8047 27.9583 14.4375 27.9583H31.8542C32.487 27.9583 33 28.4713 33 29.1042C33 29.737 32.487 30.25 31.8542 30.25H14.4375C12.539 30.25 11 28.711 11 26.8125V14.8958ZM25.6667 14.8958C25.6667 14.263 26.1797 13.75 26.8125 13.75H31.3958C32.2818 13.75 33 14.4682 33 15.3542V19.9375C33 20.5703 32.487 21.0833 31.8542 21.0833C31.2213 21.0833 30.7083 20.5703 30.7083 19.9375V17.6621L26.2858 22.0847C25.1962 23.1742 23.4556 23.2532 22.2719 22.2668L20.6835 20.9431C20.416 20.7201 20.0241 20.7324 19.7711 20.9716L17.3483 23.2619C16.4286 24.1314 14.9781 24.0906 14.1087 23.1709L18.1968 19.3063C19.2932 18.2698 20.9915 18.2166 22.1506 19.1825L23.739 20.5063C24.0122 20.7339 24.4139 20.7157 24.6653 20.4642L29.0879 16.0417H26.8125C26.1797 16.0417 25.6667 15.5287 25.6667 14.8958Z",
    fill: "#8888B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.6212ea5f.svg";
export { ForwardRef as ReactComponent };